var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomUniqueVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 3V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8H20",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 17H11C10.4696 17 9.96086 16.7893 9.58579 16.4142C9.21071 16.0391 9 15.5304 9 15V5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H15L20 8V15C20 15.5304 19.7893 16.0391 19.4142 16.4142C19.0391 16.7893 18.5304 17 18 17Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 17V19C16 19.5304 15.7893 20.0391 15.4142 20.4142C15.0391 20.7893 14.5304 21 14 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V9C5 8.46957 5.21071 7.96086 5.58579 7.58579C5.96086 7.21071 6.46957 7 7 7H9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomUniqueVisitors);
export default __webpack_public_path__ + "static/media/room-unique-visitors.1b09f7a09ccc52304b980ae4412d9185.svg";
export { ForwardRef as ReactComponent };